var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "item-unit-modal" }, [
    _vm._m(0),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "card-footer" },
      [
        _c(
          "base-button",
          {
            staticClass: "collapse-button mr-3",
            attrs: { loading: _vm.isLoading, icon: "save", color: "theme" },
            on: {
              click: function ($event) {
                return _vm.submitPrepaymentRequestData("Rejected")
              },
            },
          },
          [
            _vm._v(
              "\n          " + _vm._s(_vm.$t("general.reject")) + "\n        "
            ),
          ]
        ),
        _vm._v(" "),
        _c(
          "base-button",
          {
            staticClass: "mr-3",
            attrs: { outline: true, color: "theme", type: "button" },
            on: {
              click: function ($event) {
                return _vm.submitPrepaymentRequestData("Verified")
              },
            },
          },
          [
            _vm._v(
              "\n          " + _vm._s(_vm.$t("general.verify")) + "\n        "
            ),
          ]
        ),
      ],
      1
    ),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "card-body" }, [
      _c("div", { staticClass: "form-group text-center" }, [
        _vm._v(
          "\n        Click action you want to perform on the invoices\n        "
        ),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }